import React, { useEffect, useState } from 'react'
import DynamicTable from '../../components/DynamicTable'
import CssBaseline from '@material-ui/core/CssBaseline'
import { API } from 'aws-amplify';
import DForm from '../../components/DForm';
import ConfirmationModal from '../../components/ConfirmationModal';
import useUIState from '../../hooks/useUIstate';
import { productFormToReqBody } from './ProductController';
import { s3put, s3remove } from '../../helpers/commonFunctions';
import { Product } from '../../interfaces/IProduct';
import TranslationModal from '../../components/TranslationModal';
import { useTranslation } from 'react-i18next';

function ProductsTable(props) {
    const { setShowLoadingModal, setToastMessage, setShowToastMessage, setToastType } = useUIState();

    const LockerSizesOptions = [
        { value: "NVT", label: "NVT" },
        { value: "180mm x 200mm", label: "180mm x 200mm" },
        { value: "180mm x 300mm", label: "180mm x 300mm" },
        { value: "180mm x 400mm", label: "180mm x 400mm" },
        { value: "247mm x 300mm", label: "247mm x 300mm" },
        { value: "372mm x 300mm", label: "372mm x 300mm" },
    ]


    const [data, setData]: [any[], any] = useState([]);
    const [showForm, setShowForm]: [boolean, any] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal]: [boolean, any] = useState(false);
    const [formValues, setFormValues]: [any, any] = useState({});
    const [activeRow, setActiveRow]: [any, any] = useState(null);
    const [formMode, setFormMode]: [string, any] = useState("");
    const [formObj, setFormObj]: [Record<string, any>[], any] = useState([]);
    const [ProductCategoriesOptions, setProductCategoriesOptions]: any = useState([]);
    const [UserConfigData, setUserConfigData]: [any, any] = useState([]);
    const [showTranslationModal, setShowTranslationModal]: [boolean, any] = useState(false);
    const [translationFormModel, setTranslationFormModel]: [any, any] = useState({});
    const [translationFormFieldsModel, setTranslationFormFieldsModel]: [any, any] = useState({});
    const [productForTranslate, setProductForTranslate]: [any, any] = useState({});
    const { t } = useTranslation();

    useEffect(() => {
        const value = localStorage.getItem("UserConfigData");
        if (typeof value === 'string') {
            setUserConfigData(JSON.parse(value));
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (props.productCategories.length) {
            createProductCategoriesOptions();
        }
    }, [props.data])

    function createProductCategoriesOptions() {
        const _pCatOptions: any[] = [];
        props.productCategories.forEach(pc => {
            _pCatOptions.push({
                value: pc.Id,
                label: pc.Title,
            })
        });
        setProductCategoriesOptions(_pCatOptions);
        renderData(_pCatOptions);
    }

    async function renderData(productCategoriesOpts) {
        const productsRender: any[] = [];

        props.data.forEach(p => {

            let attr = p.Attributes;
            attr = attr.replace(/'/g, '"');
            attr = JSON.parse(attr);

            let pcTitle = productCategoriesOpts.find(pc => pc.value === p.ProductCategoryId).label;

            productsRender.push({
                Id: p.Id,
                ProductCategoryId: p.ProductCategoryId,
                ProductCategoryTitle: pcTitle,
                Code: p.Code,
                DefaultPrice: p.DefaultPrice,
                VAT: p.VAT,
                IsOnStartPage: p.IsOnStartPage ? 'Yes' : 'No',
                Title: p.Title,
                Description: p.Description,
                Avatar: p.Avatar ? p.Avatar : " ",
                ShelfLifeDays: attr.ShelfLifeDays,
                LockerSize: attr.LockerSize,
                Priority: attr.Priority,
                Weight: attr.Priority === "Weight" ?
                    attr.Weight : "",
                Amount: attr.Priority === "Amount" ?
                    attr.Amount : "",
                Enabled: attr.Enabled ? 'Yes' : 'No',
            })
        });

        setData(productsRender);
        setShowLoadingModal(false);
    }


    async function createOrUpdateProduct(reqBody: Product) {
        let path = '/Products';
        let body: Product = reqBody;
        if (reqBody.Id) { body.Id = reqBody.Id };
        let res;
        if (reqBody.Id) {
            res = await API.put('AE', path, { body });
        } else {
            res = await API.post('AE', path, { body });
        }
        return res;
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'Id',
                accessor: 'Id',
                hide: true,
            },
            {
                Header: 'ProductCategoryId',
                accessor: 'ProductCategoryId',
                hide: true,
            },
            {
                Header: 'StoreId',
                accessor: 'StoreId',
                hide: true,
            },
            {
                Header: t('productstable.code'),
                accessor: 'Code',
            },
            {
                Header: t('productstable.name'),
                accessor: 'Title',
            },
            {
                Header: t('productstable.category'),
                accessor: 'ProductCategoryTitle',
            },
            {
                Header: t('productstable.default-price'),
                accessor: 'DefaultPrice',
            },
            {
                Header: t('productstable.btw'),
                accessor: 'VAT',
            },
            {
                Header: t('productstable.description'),
                accessor: 'Description',
                hide: true,
            },
            {
                Header: t('productstable.avatar'),
                accessor: 'Avatar',
                hide: true,
            },
            {
                Header: t('productstable.shelflifedays'),
                accessor: 'ShelfLifeDays',
                // hide: true,
            },
            {
                Header: t('productstable.amount-weight'),
                accessor: 'Priority',
                // hide: true,
            },
            {
                Header: t('productstable.weight'),
                accessor: 'Weight',
                // hide: true,
            },
            {
                Header: t('productstable.amount'),
                accessor: 'Amount',
                // hide: true,
            },
            {
                Header: t('productstable.locker-size'),
                accessor: 'LockerSize',
                // hide: true,
            },
            {
                Header: t('productstable.popular-product'),
                accessor: 'IsOnStartPage',
            },
            {
                Header: t('productstable.active'),
                accessor: 'Enabled',
            },
        ],
        []
    );

    function prepForm(row) {
        const rowValues = row !== null ? row.original : null;
        const addingRow = rowValues === null;

        const _formValues = {
            Code: addingRow ? "" : rowValues.Code,
            Title: addingRow ? "" : rowValues.Title,
            DefaultPrice: addingRow ? 0 : rowValues.DefaultPrice,
            VAT: addingRow ? 9 : rowValues.VAT,
            IsOnStartPage: addingRow ? false : rowValues.IsOnStartPage === "Yes" ? true : false,
            Enabled: addingRow ? true : rowValues.Enabled === "Yes" ? true : false,
            Description: addingRow ? "" : rowValues.Description,
            Avatar: addingRow ? "" : rowValues.Avatar,
            ShelfLifeDays: addingRow ? "" : rowValues.ShelfLifeDays,
            LockerSize: addingRow ? LockerSizesOptions[0].value : rowValues.LockerSize,
            Priority: addingRow ? "Weight" : rowValues.Priority,
            ProductCategoryId: addingRow ? ProductCategoriesOptions[0].value : rowValues.ProductCategoryId,
            Amount: addingRow ? "" : rowValues.Amount,
            Weight: addingRow ? "" : rowValues.Weight,
        }

        const formObj = [
            {
                name: "Code",
                type: "text",
                label: t('productstable.code'),
                required: true,
                disabled: addingRow ? false : true,
                initialValue: addingRow ? "" : rowValues.Code
            },
            {
                name: "Title",
                type: "text",
                label: t('productstable.name'),
                required: true,
                initialValue: addingRow ? "" : rowValues.Title
            },
            {
                name: "ProductCategoryId",
                type: "select",
                label: t('productstable.category'),
                required: true,
                initialValue: _formValues.ProductCategoryId,
                options: ProductCategoriesOptions
            },
            {
                name: "DefaultPrice",
                type: "number",
                label: t('productstable.default-price'),
                required: true,
                initialValue: addingRow ? "" : rowValues.DefaultPrice
            },
            {
                name: "VAT",
                type: "number",
                label: t('productstable.btw'),
                initialValue: addingRow ? "" : rowValues.VAT
            },
            {
                name: "Description",
                type: "text",
                label: t('productstable.description'),
                initialValue: addingRow ? "" : rowValues.Description
            },
            {
                name: "ShelfLifeDays",
                type: "number",
                label: t('productstable.shelflifedays'),
                required: true,
                initialValue: addingRow ? "" : rowValues.ShelfLifeDays
            },
            {
                name: "LockerSize",
                type: "select",
                label: t('productstable.locker-size'),
                required: true,
                initialValue: addingRow ?
                    LockerSizesOptions[0].value :
                    rowValues.LockerSize,
                options: LockerSizesOptions
            },
            {
                name: "Priority",
                type: "select",
                label: t('productstable.amount-weight'),
                required: true,
                initialValue: addingRow ? "Weight" : rowValues.Priority,
                options: [
                    { label: t('productstable.weight'), value: "Weight" },
                    { label: t('productstable.amount'), value: "Amount" },
                ]
            },
            {
                name: "Weight",
                type: "text",
                label: t('productstable.weight'),
                initialValue: addingRow ? "" : rowValues.Weight
            },
            {
                name: "Amount",
                type: "number",
                label: t('productstable.amount'),
                initialValue: addingRow ? "" : rowValues.Amount
            },
            {
                name: "IsOnStartPage",
                type: "checkbox",
                label: t('productstable.popular-product'),
                checked: addingRow ? false : rowValues.IsOnStartPage === 'Yes' ? true : false
            },
            {
                name: "Enabled",
                type: "checkbox",
                label: t('productstable.active'),
                checked: addingRow ? false : rowValues.Enabled === 'Yes' ? true : false
            },

            {
                name: "Avatar",
                type: "file",
                label: t('generic.select'),
                objUrl: addingRow ? "" : rowValues.Avatar.trim() ? UserConfigData.Customer + '/images/products/pid' + rowValues.Id + "_" + rowValues.Avatar : "",
                maxHeight: 320,
                maxWidth: 320
            },

        ];
        setFormObj(formObj);

        setActiveRow(rowValues);
        setFormMode(rowValues === null ? "Add" : "Edit");
        setFormValues(_formValues);
        setShowForm(true);
    }

    function prepTranslation(row) {
        setShowLoadingModal(true);
        API.get("AE", `/Translations/GetProductTranslations?productId=${row.values.Id}`, { response: true })
            .then(res => {
                let data = res.data;
                let fields = [{ name: 'LanguageCode', input: false }, { name: 'Title', input: true }, { name: 'Description', input: true }];
                setTranslationFormModel(data);
                setTranslationFormFieldsModel(fields);
                setProductForTranslate(row.values);
                setShowTranslationModal(true);
            })
            .catch(error => {
                console.log(error);
                setToastType("error");
                setToastMessage(t('productstable.error.getting-products'));
                setShowToastMessage(true);
            })
            .finally(() => {
                setShowLoadingModal(false);
            })
    }

    async function submit(values) {

        let validated = true;

        if (values.VAT === 0) {
            setToastType("error");
            setToastMessage(t('productstable.error.0-btw'));
            setShowToastMessage(true);
            validated = false;
        }

        if (!values.Avatar || values.Avatar === " ") {
            setToastType("error");
            setToastMessage(t('productstable.error.add-image'));
            setShowToastMessage(true);
            validated = false;
        }

        // check for unique code
        if (data.find(el => el.Code === values.Code)) {
            let valueExists;
            if (activeRow === null) {
                valueExists = true;
            } else {
                if (data.find(el => el.Code === values.Code).Id !== activeRow.Id) {
                    valueExists = true;
                }
            }
            if (valueExists) {
                setToastType("error");
                setToastMessage(t('productstable.error.code-exists'));
                setShowToastMessage(true);
                validated = false;
            }
        }

        if (validated) {
            setShowLoadingModal(true);
            const reqBody = productFormToReqBody(activeRow, values);

            setShowForm(false);

            const res = await createOrUpdateProduct(reqBody);
            if (res) {
                setToastType("success");
                //setToastMessage(`Product ${activeRow === null ? "added" : "edited"} successfully!`);
                setToastMessage(
                t('productstable.edit-success', {
                    product: t('productstable.product'),
                    action: activeRow === null ? t('generic.added') : t('generic.edited')
                })
                );
                setShowToastMessage(true);
                props.getData();
            } else {
                setToastType("error");
                //setToastMessage(`Error ${activeRow === null ? "adding" : "editing"} Product`);
                setToastMessage(
                t('productstable.edit-fail', {
                    error: t('generic.error'),
                    action: activeRow === null ? t('generic.adding') : t('generic.editing'),
                    product: t('productstable.product')
                })
                );
                setShowToastMessage(true);
            }

            let putResp;
            let imageChange;

            if (activeRow) {
                if (values.Avatar !== activeRow.Avatar) {
                    imageChange = true;
                    putResp = await s3put(`${UserConfigData.Customer}/images/products/pid${res.Id}_${reqBody.Avatar}`, values.Avatar);
                }
            } else {
                imageChange = true;
                putResp = await s3put(`${UserConfigData.Customer}/images/products/pid${res.Id}_${reqBody.Avatar}`, values.Avatar);
            }

            if (!putResp && imageChange) {
                setToastType("error");
                setToastMessage(t('productstable.error.image-upload'));
                setShowToastMessage(true);
            }

            setShowLoadingModal(false);
        }
    }

    async function submitTranslationValue(rows) {
        let path = `/Translations/AddOrUpdateProductTranslations?productId=${productForTranslate.Id}`;
        let body = rows;
        await API.post('AE', path, { body });
        setShowTranslationModal(false);
        setToastType("success");
        setToastMessage(t('productstable.translation-saved'));
        setShowToastMessage(true);
    }

    function handleDeleteConfirmation(row) {
        setActiveRow(row);
        setShowConfirmationModal(true);
    }

    async function deleteEntry() {
        let path = '/Products';
        let myInit = {}
        try {
            setToastType("success");
            setToastMessage(t('productstable.product-deleted'));
            setShowToastMessage(true);
            return await API.del('AE', path + "?productId=" + activeRow.original.Id, myInit);
        } catch (err) {
            console.log(err);
            setToastType("error");
            setToastMessage(t('productstable.error.delete-product'));
            setShowToastMessage(true);
            return null;
        }
    }

    async function confirmDelete() {
        setShowLoadingModal(true);
        setShowConfirmationModal(false);
        const deleted = await deleteEntry();
        if (deleted) {
            if (activeRow.original.Avatar.trim()) {
                const filePath = `${UserConfigData.Customer}/images/products/pid${activeRow.original.Id}_${activeRow.original.Avatar}`
                const res = await s3remove(filePath);
                if (!res) {
                    setToastType("error");
                    setToastMessage(t('productstable.error.delete-image'));
                    setShowToastMessage(true);
                }
            }
        }
        props.getData();
    }


    return (
        <div>
            <h2 className="mb-05">{t('productstable.products')}</h2>
            <CssBaseline />
            <DynamicTable
                className="Products"
                addRow={() => prepForm(null)}
                editRow={(row) => prepForm(row)}
                editRowTranslation={(row) => prepTranslation(row)}
                // deleteRow={(row) => handleDeleteConfirmation(row)}
                columns={columns}
                data={data}
                loading={false}
                globalFilter={true}
                showActiveField={true}
            />
            {
                showForm ?
                    <DForm
                        formObj={formObj}
                        formMode={formMode}
                        initialValues={formValues}
                        closeModal={() => setShowForm(false)}
                        submit={submit}
                    />
                    : null
            }
            {
                showTranslationModal ?
                    <TranslationModal
                        rows={translationFormModel}
                        fields={translationFormFieldsModel}
                        product={productForTranslate}
                        closeModal={() => setShowTranslationModal(false)}
                        save={submitTranslationValue}
                    />
                    : null
            }
            {showConfirmationModal ?
                <ConfirmationModal
                    message={t('productstable.question-delete-product')}
                    confirm={confirmDelete}
                    closeModal={() => setShowConfirmationModal(false)}
                />
                : null}
        </div>
    )
}

export default ProductsTable;
